import LINKS from "@/lib/links";
import { Component } from "@builder.io/sdk";

export const ctaServicesConfig: Component = {
  name: "CTA Services",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "cta-services",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "primary",
      type: "object",
      friendlyName: "Primary CTA",
      helperText: "Primary CTA configuration",
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Button Label",
          defaultValue: "Need Urgent Care?",
          required: true,
        },
        {
          name: "button",
          type: "string",
          friendlyName: "Button Text",
          defaultValue: "Get Care Now",
          required: true,
        },
        {
          name: "href",
          type: "string",
          friendlyName: "Button Link",
          defaultValue: LINKS.careAssessmentServicesPrefilled.href,
          required: true,
        },
      ],
      defaultValue: {
        title: "Need Urgent Care?",
        button: "Get Care Now",
        href: LINKS.careAssessmentServicesPrefilled.href,
      },
    },
    {
      name: "secondary1",
      type: "object",
      friendlyName: "Secondary CTA 1",
      helperText: "First secondary CTA configuration",
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Button Label",
          defaultValue: "Get More Details",
          required: true,
        },
        {
          name: "button",
          type: "string",
          friendlyName: "Button Text",
          defaultValue: "Learn More",
          required: true,
        },
        {
          name: "href",
          type: "string",
          friendlyName: "Button Link",
          defaultValue: LINKS.inquiryForm.href,
          required: true,
        },
      ],
      defaultValue: {
        title: "Get More Details",
        button: "Learn More",
        href: LINKS.inquiryForm.href,
      },
    },
    {
      name: "secondary2",
      type: "object",
      friendlyName: "Secondary CTA 2",
      helperText: "Second secondary CTA configuration",
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Button Label",
          defaultValue: "Get More Details",
          required: true,
        },
        {
          name: "icon",
          type: "string",
          enum: ["map-pin", "phone", "mail", "clock", "none"],
          defaultValue: "none",
        },
        {
          name: "button",
          type: "string",
          friendlyName: "Button Text",
          defaultValue: "Learn More",
          required: true,
        },
        {
          name: "href",
          type: "string",
          friendlyName: "Button Link",
          defaultValue: LINKS.inquiryForm.href,
          required: true,
        },
      ],
      defaultValue: {
        title: "Get More Details",
        button: "Learn More",
        href: LINKS.inquiryForm.href,
      },
    },
  ],
};
